module.exports = __webpack_public_path__ + "img/hr-wooden-particle-21.31b3ca35.png";